import { Box, Button, Chip, Stack, Tooltip, Typography, ValidationErrors, newToast, openFile } from "@compass/core";
import { SubmitButton } from "components";
import { Export, ExportGridData, ExportPreviewInfo } from "generated/openApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import PreviewIcon from '@mui/icons-material/Preview';

export const SurveyReportHeader = (props: {
  handle: string;
  _export: Export | undefined;
  setGridData: React.Dispatch<React.SetStateAction<ExportGridData | undefined>>;
  screen: "config" | "grid";
  setScreen: React.Dispatch<React.SetStateAction<"config" | "grid">>;
  setValidationErrors: (errors: ValidationErrors) => void;
}) => {
  const dispatch = useDispatch();

  const [previewInfo, setPreviewInfo] = useState<ExportPreviewInfo>();
  const [canGetPreviewInfo, setCanGetPreviewInfo] = useState<boolean>(true);

  useEffect(() => {
    if (props._export?.exportTypeId) {
      setCanGetPreviewInfo(true);
    }
  }, [props._export]);

  const generateGridData = (_export: Export | undefined) => {
    props.setValidationErrors({});

    ApiService.exports
      .generateGridData(_export!)
      .then((response) => {
        props.setGridData(response);
        props.setScreen("grid");
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.screen === "config" && (
          <SubmitButton label="Generate" onClick={() => generateGridData(props._export)} />
        )}
        {props.screen === "grid" && (
          <Button onClick={() => props.setScreen("config")} variant="outlined">
            Back
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
